import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("LocalsConfigObj", {
  hideInSelectionDialogs: true,
  properties: ["locals"],
  initialContent: {
    locals: "{}",
  },
});
